export class DynamoDBAdvancedIndexConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "localSecondaryIndexMode",
            "baseName": "localSecondaryIndexMode",
            "type": "IndexRestoreMode",
            "format": ""
        },
        {
            "name": "globalSecondaryIndexMode",
            "baseName": "globalSecondaryIndexMode",
            "type": "IndexRestoreMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDBAdvancedIndexConfig.attributeTypeMap;
    }
    constructor() {
    }
}
